import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Json = () => {
  return (
    <StartInterviewLayout type="json"/>
  )
}

export default Json;